<div>
    <div class="test" style="text-align: center">
      <div class="col-sm-12">
        <h3>{{title}}</h3>
      </div>
           
      <div class="col-sm-12" [formGroup]="commForm">
        <mat-icon class="col-sm-2" style="bottom: auto;" [color]="icon_color">{{icone}}</mat-icon>
        <mat-form-field class="full-width">

          <mat-label style="margin-left: 5px;">Commentaire</mat-label>
          <textarea matInput name="nth-ref-obs" cdkTextareaAutosize cdkAutosizeMinRows="8"
              cdkAutosizeMaxRows="10" style="background-color: white;"
              maxlength="255"
              formControlName="commentaires">
            </textarea>
            <mat-error *ngIf="commForm.get('commentaires').hasError('required')">
              Veuillez saisir un commentaire
          </mat-error>
        </mat-form-field>
      </div> 
      <div class="col-sm-12">
        <mat-divider></mat-divider>
      </div>
      <div class="row">
        <div class="col-sm-6" style="margin-top: 40px;">
          <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
        </div>
        <div class="col-sm-6" style="margin-top: 40px;">
          <button mat-raised-button [color]="color" (click)="onModalConfirm()" >Confirmer</button>
        </div>
      </div>
      
    </div>
  </div>